export default __webpack_public_path__ + "static/media/card-profile2-square.b2f1768e.jpg";